/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type getRecentHistory_item = {
    readonly contemporaryTrackingString: string;
    readonly firstPhotoWebPath: string | null;
    readonly pdpURL: string | null;
    readonly title: string | null;
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly serviceId: string | null;
    readonly categoryPath: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": "getRecentHistory_item";
};
export type getRecentHistory_item$data = getRecentHistory_item;
export type getRecentHistory_item$key = {
    readonly " $data"?: getRecentHistory_item$data;
    readonly " $fragmentRefs": FragmentRefs<"getRecentHistory_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "getRecentHistory_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contemporaryTrackingString",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = 'a8f3ab58525b5cceb6d39885d9a4a88a';
export default node;
